import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import './SavingsDashboard.css';
function SavingsDashboard() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        const token = localStorage.getItem('tankly_token');
        if (!token) {
            navigate('/login');
            return;
        }
        const rawUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';
        let baseUrl = rawUrl.trim();
        if (!baseUrl.startsWith('http')) baseUrl = `https://${baseUrl}`;
        axios.get(`${baseUrl}/api/routes/savings`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
            .then(res => {
                setData(res.data);
                setLoading(false);
            })
            .catch(err => {
                console.error('Failed to load savings', err);
                if (err.response?.status === 403 || err.response?.status === 401) {
                    localStorage.removeItem('tankly_token');
                    navigate('/login');
                } else {
                    setError('Could not load savings data. Please try again.');
                    setLoading(false);
                }
            });
    }, [navigate]);
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit', month: 'short', year: 'numeric'
        });
    };
    if (loading) {
        return (
            <div className="savings-page">
                <div className="savings-loading">Loading your savings data…</div>
            </div>
        );
    }
    if (error) {
        return (
            <div className="savings-page">
                <div className="savings-loading">{error}</div>
            </div>
        );
    }
    return (
        <div className="savings-page">
            <header className="savings-header">
                <div className="savings-header-left">
                    <img className="savings-logo" src="/tankly_logo.svg" alt="Tankly" />
                </div>
                <Link to="/" className="savings-back">← Back to Dashboard</Link>
            </header>
            <div className="savings-content">
                <h1 className="savings-title">Your Savings Overview</h1>
                <p className="savings-subtitle">
                    Track how much money Tankly has saved your company.
                </p>
                <div className="savings-cards">
                    <div className="savings-card">
                        <p className="savings-card-label">Total Savings</p>
                        <p className="savings-card-value highlight">
                            €{data.totalSavings.toFixed(2)}
                        </p>
                    </div>
                    <div className="savings-card">
                        <p className="savings-card-label">Total Searches</p>
                        <p className="savings-card-value">
                            {data.totalSearches}
                        </p>
                    </div>
                    <div className="savings-card">
                        <p className="savings-card-label">Avg Savings / Search</p>
                        <p className="savings-card-value">
                            €{data.averageSavingsPerSearch.toFixed(2)}
                        </p>
                    </div>
                </div>
                <div className="savings-table-section">
                    <h2>Search History</h2>
                    {data.recentSearches.length === 0 ? (
                        <div className="savings-empty">
                            No searches yet. Use the route planner to find your first fuel stop!
                        </div>
                    ) : (
                        <div className="savings-table-wrap">
                            <table className="savings-table">
                                <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Route</th>
                                    <th>Station Selected</th>
                                    <th>Savings</th>
                                </tr>
                                </thead>
                                <tbody>
                                {data.recentSearches.map((search) => (
                                    <tr key={search.id}>
                                        <td className="mono">
                                            {formatDate(search.createdAt)}
                                        </td>
                                        <td>
                                            {search.fromLocation} → {search.toLocation}
                                        </td>
                                        <td>
                                            {search.selectedStation
                                                ? search.selectedStation
                                                : <span className="text-muted">No station selected</span>
                                            }
                                        </td>
                                        <td className={`mono ${search.savingsForThisSearch > 0 ? 'text-green' : ''}`}>
                                            €{search.savingsForThisSearch.toFixed(2)}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
export default SavingsDashboard;